export default (hit, isInit) => {
  let date = new Date(hit.date.date)

  if (hit.locale === 'en') {
    date = `${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getDate().toString().padStart(2, '0')}.${date.getFullYear()}`
  } else {
    date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
  }

  return `
  <a ${isInit ? 'js-scroll-animations-target style="opacity: 0"' : ''} href="${hit.path}" class="display-mobile news-card">
    <img class="w-full" src="https://res.cloudinary.com/dbozkenbr/image/upload/c_fill,f_auto,q_auto,w_500,h_500/${hit.picture.singleMedia.publicId}" alt="${hit.picture.singleMedia.alt}" />
    <div class="flex justify-between mt-4">
        <p class="news-card__tag news-card__tag--${hit.newsType}">${config.trads[`news.type.${hit.newsType}`]}</p>
        <p class="text-12 md:text-13">${date}</p>
    </div>
    <p class="title-secondary--5 font-secondary mt-4">${hit.title}</p>
    <span class="link news-card__link mt-4 mb-8">
        <span>${config.trads['news.know_more']}</span>
        <svg width="12" height="12">
            <use href="#icon-arrow-cta" xlink:href="#icon-arrow-cta" />
        </svg>
    </span>
  </a>
  `
}
